<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="name" :label="$t('名称')">
<!--        <span slot="label">
          <a-tooltip>
            名称<template slot="title">名称</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.name" :maxLength="100" :placeholder="$t('请输入')+$t('名称')" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['name']"
            input-type="input"
            table-name="discover_channel_category"
            table-field="name"
            :field-value="form.name"
          />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="imageUrl"  :label="$t('图片')">
<!--        <span slot="label">
          <a-tooltip>
            图片<template slot="title">图片</template>
          </a-tooltip>
        </span>-->
        <oss-upload-single v-model="form.imageUrl" prefix="channel" type="img" />
      </a-form-model-item>
      <a-form-model-item prop="sort" :label="$t('排序')">
<!--        <span slot="label">
          <a-tooltip>
            排序<template slot="title">排序</template>
          </a-tooltip>
        </span>-->
        <a-input-number style="width: 100%;" v-model="form.sort" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item prop="isEnabled" :label="$t('状态')">
<!--        <span slot="label">
          <a-tooltip>
            状态<template slot="title">状态</template>
          </a-tooltip>
        </span>-->
        <a-switch v-model="form.isEnabled"></a-switch>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDiscoveryChannelCategory, addDiscoveryChannelCategory, updateDiscoveryChannelCategory } from '@/api/discovery/discoveryChannelCategory'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    OssUploadSingle,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        imageUrl: null,

        sort: null,

        isEnabled: null,

        createTime: null,
        localeFieldMap:{},

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '名称' + this.$t('不能为空'), trigger: 'blur' }
        ],
        imageUrl: [
          { required: true, message: '图片' + this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序' + this.$t('不能为空'), trigger: 'blur' }
        ],
        isEnabled: [
          { required: true, message: '状态' + this.$t('不能为空'), trigger: 'change' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        imageUrl: null,
        sort: null,
        isEnabled: false,
        createTime: null,
        localeFieldMap:{},
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDiscoveryChannelCategory({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateDiscoveryChannelCategory(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addDiscoveryChannelCategory(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
